import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { USER_TYPE } from '../../config/const';
import CreatorProfile from './creatorProfile';
import FanProfilePage from './fanProfile';
import LoadingPage from '../LoadingPage';
import { useLocation} from 'react-router-dom';
// import ProfileNav from '.././ProfileNav/Index';

export default function UserProfile() {
  const { authUser, authLoading } = useAuth();
  const { userName: userNameParam } = useParams();
  const userName = userNameParam?.toLowerCase();
  const location = useLocation();
  const passedProduct = location.state?.product;
  
  return authLoading ? (
    <LoadingPage />
  ) : (
    <Box display='flex' justifyContent='center' width='100%' height='100%'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          px: { xs: 1.5, sm: 2.5 },
          py: { xs: 1.5, sm: 0 },
          maxWidth: { xs: '100dvw', md: '1200px' },
        }}
      >
        {authUser?.userType === USER_TYPE.FOLLOWER &&
        authUser?.normalizedUserName === userName ? (
          <FanProfilePage />
        ) : (
          <CreatorProfile passedProduct={passedProduct} />
        )}
      </Box>
    </Box>
  );
}
